import React, { Fragment } from 'react';
import { useEffect, useState } from 'react';
import { Card, Form, Table, Button } from 'react-bootstrap';
import { MdBrightness5 } from "react-icons/md";
import { formatoMonto } from '../../../../../common/Formatos';
import AddPago from './pago';


const Implicados = ({ cfg_form, implicados, fechaIngreso, setPagoSubmit, procesoSelected }) => {
    const [sowModalPago, setShowModalPago] = useState(false);
    const [montosBool, setMontosBool] = useState([]);
    const [implicadoSelect, setImplicadoSelect] = useState(null);
    
    useEffect(() => {
        if (implicados) {
            const auxBools = [];
            implicados.forEach(i => {
                if (i.montoApagar > 0) auxBools.push(true);
                else auxBools.push(false);
            });

            setMontosBool(auxBools);
        }
    }, [implicados])

    const handleChange = (checked, pos) => {
        const auxCheckeds = [...montosBool];
        auxCheckeds[pos] = checked;

        setMontosBool(auxCheckeds);
    }

    const handleModalPago = (impl) => {
        setShowModalPago(true);
        setImplicadoSelect(impl);
    }

    return (
        <Fragment>
            <Card className='my-4'>
                <Card.Header className="customHeaderCard">
                    {cfg_form && cfg_form["modalgestioncierre-grillaimplicados-title"]}
                </Card.Header>

                <Card.Body className="customCard">
                    <Table striped className="customTable">
                        <thead>

                            <tr>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaimplicados-id"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaimplicados-nombre"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaimplicados-tipoimpl"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaimplicados-patente"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaimplicados-estado"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaimplicados-fecestado"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaimplicados-aplpago"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaimplicados-mtopagar"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaimplicados-seguro"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaimplicados-cia"]}</th>
                                <th style={{ textAlign: 'center' }}></th>
                            </tr>

                        </thead>
                        <tbody>
                            {implicados?.map((implicado, index) => (
                                <tr key={index}>
                                    <td style={{ textAlign: 'center' }}>{implicado.idImplicado}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.nombreImplicado}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.glosaBienImplicado}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.patenteImplicado}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.estadoImplicado}</td>
                                    <td style={{ textAlign: 'center', width: '10%' }}>{implicado.fechaEstadoImplFormat}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <Form.Check
                                            onChange={(e) => handleChange(e.target.checked, index)}
                                            checked={montosBool[index] ? montosBool[index] : false}
                                        />
                                    </td>
                                    <td style={{ textAlign: 'center' }}>{formatoMonto(implicado.montoApagar)} {implicado.monedaIngreso}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.seguroImplicado}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.ciaImplicado}</td>
                                    <td style={{ textAlign: 'right' }}>
                                        <Button disabled={!montosBool[index]} variant='opciones me-md-2' size='sm' onClick={() => handleModalPago(implicado)}>
                                            <MdBrightness5 size={20} />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    {implicados?.length === 0 &&
                        <span style={{ display: 'inherit', textAlign: 'center' }}>No hay registros encontrados.</span>
                    }
                </Card.Body>
            </Card>

            <AddPago
                showModal={sowModalPago}
                setShowModal={setShowModalPago}
                implicado={implicadoSelect?.idImplicado}
                fechaIngreso={fechaIngreso}
                setPagoSubmit={setPagoSubmit}            
                procesoSelected={procesoSelected}
            />
           

            <style type='text/css'>
                {`
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                    }
                    .customHeaderCard {
                        background-color: rgb(176 175 196);
                        color: #3a3a8d;
                        font-size: 17px;
                        font-weight: 600
                    }
                    .customTable > thead {
                        color: white; 
                        background-color: rgb(114, 139, 176);
                    }
                    .customTable > thead > tr > th {
                        padding: 20px 0;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default Implicados;